import * as React from 'react'
import { scroll } from '../../../lib/utils'
import { defineMessages } from 'react-intl'

import Hero from './components/hero'
import Intro from './components/intro'
import styles from './signup.module.scss'
import Fitting from './components/fitting'
import Features from './components/features'

import Footer from '../../../sections/footer'
import SimpleFaq from '../../../sections/simple-faq'
import WaveContainer from '../../../components/wave-container'
import PrettyContactForm from '../../../components/design/pretty-contact-form'
import Seo from '../../../components/seo'

const messages = defineMessages({
  question1: {
    defaultMessage: 'Vad behöver jag göra om jag byter från en annan byrå?',
    id: 'landing-page.signup.faq.question-1',
  },
  answer1: {
    defaultMessage:
      'Ingenting just nu, vi kommer att kontakta dig och gå igenom hur du flyttar, vilket material som vi behöver samt att vi hjälper dig med kontakten med din nuvarande byrå.',
    id: 'landing-page.signup.faq.answer-1',
  },
  question2: {
    defaultMessage: 'Hur lång tid tar det att komma igång med Dooer?',
    id: 'landing-page.signup.faq.question-2',
  },
  answer2: {
    defaultMessage:
      'Är ditt bolag nystartat går det snabbt, vi går igenom ditt företag och sedan kör vi. Flyttar du din bokföring måste vi komma överens om ett datum för flytten och efter detta gå igenom befintlig bokföring.',
    id: 'landing-page.signup.faq.answer-2',
  },
  question3: {
    defaultMessage: 'Är det verkligen säkert att använda Dooer med mitt BankID?',
    id: 'landing-page.signup.faq.question-3',
  },
  answer3: {
    defaultMessage:
      'Ja, vi använder de senaste säkerhets-teknikerna och är noga med vad vi sparar och hur. Vill du veta mer kan du läsa vår <a target="_blank" rel="noopener noreferrer" href="/gdpr">integritetspolicy</a>.',
    id: 'landing-page.signup.faq.answer-3',
  },
  question4: {
    defaultMessage: 'Vad skiljer Dooer från en traditionell bokföringsbyrå?',
    id: 'landing-page.signup.faq.question-4',
  },
  answer4: {
    defaultMessage:
      'Den stora skillnaden är att vi förutom att ha ekonomer som gör din bokföring även bygger våra egna system. Det gör att vi kan optimera arbetet bättre samt förbättra kommunikationen mellan dig och din ekonom.',
    id: 'landing-page.signup.faq.answer-4',
  },
  question5: {
    defaultMessage: 'Jag vet att det finns problem i min bokföring, kan ni hjälpa till?',
    id: 'landing-page.signup.faq.question-5',
  },
  answer5: {
    defaultMessage:
      'Självklart, när vi får din bokföring kommer den att kontrolleras. Vi kommer då att rapportera problem som vi hittar samt ge ett förslag på åtgärder och pris.',
    id: 'landing-page.signup.faq.answer-5',
  },
  question6: {
    defaultMessage: 'Kan jag bli kund hos Dooer?',
    id: 'landing-page.signup.faq.question-6',
  },
  answer6: {
    defaultMessage:
      'Idag tar vi enbart emot aktiebolag som fakturerar sina kunder och inte har mer avancerade skatteregler. Vi kan exempelvis inte ta emot butiker, ehandel, byggföretag med omvänd moms eller sjukvårdsföretag med blandad moms.',
    id: 'landing-page.signup.faq.answer-6',
  },
})

const qas = [
  {
    q: messages.question1,
    a: messages.answer1,
  },
  {
    q: messages.question2,
    a: messages.answer2,
  },
  {
    q: messages.question3,
    a: messages.answer3,
  },
  {
    q: messages.question4,
    a: messages.answer4,
  },
  {
    q: messages.question5,
    a: messages.answer5,
  },
  {
    q: messages.question6,
    a: messages.answer6,
  },
]

function Signup() {
  const contactFormRef = React.createRef<HTMLDivElement>()

  return (
    <>
      <Seo
        description="Hantera hela ditt företag i en app. Du laddar bara upp allt material till oss så gör våra ekonomer hela din bokföring."
        image="https://www.dooer.com/images/og/og_lp_signup.jpg"
        title="Få en enklare och modernare bokföring"
        url="https://www.dooer.com/lp/signup"
      />

      <div className={styles.root}>
        <Hero onCtaClick={() => scroll(contactFormRef)} />
        <WaveContainer className={styles.introWrapper}>
          <Intro />
        </WaveContainer>
        <div className={styles.priceGridWrapper}>
          <div ref={contactFormRef}>
            <PrettyContactForm />
          </div>
        </div>
        <Fitting />
        <WaveContainer>
          <Features onCtaClick={() => scroll(contactFormRef)} />
        </WaveContainer>
        <SimpleFaq
          customHeading={{ defaultMessage: 'Vanliga frågor', id: 'landing-pages.signup.faq.heading' }}
          customQas={qas}
        />
        <Footer inverted />
      </div>
    </>
  )
}

export default Signup
